import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { EMPTY, from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { API_SCOPE } from '../../app.config';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ApiAuthInterceptor implements HttpInterceptor {
  private readonly auth = inject(AuthService);
  private readonly msal = inject(MsalService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const shouldAttachToken =
      req.url.startsWith(environment.urlApi) && !req.headers.has('Authorization');

    if (!shouldAttachToken) {
      return next.handle(req);
    }

    const account = this.auth.getActiveAccount();
    if (!account) {
      this.auth.login();
      return EMPTY;
    }

    return from(
      this.msal.instance.acquireTokenSilent({
        scopes: [API_SCOPE],
        account,
      }),
    ).pipe(
      switchMap((result) =>
        next.handle(
          req.clone({
            setHeaders: {
              Authorization: `Bearer ${result.accessToken}`,
            },
          }),
        ),
      ),
      catchError((error: unknown) => {
        if (error instanceof InteractionRequiredAuthError) {
          this.auth.login();
          return EMPTY;
        }

        return throwError(() => error);
      }),
    );
  }
}
